<template>
  <div>
    <div v-if="loading" class="text-xs-center" id="center">
      <v-progress-circular :size="120" :width="7" color="orange" indeterminate></v-progress-circular>
    </div>
 
    <div v-else>

      <div class="col-12" id="frame">
        <div class="card">  
          <div class="card-header text-xs-inline" id="graphheader">
            <h4 class="card-title">
              heimspiel Lieferservice Umsätze
              <v-btn flat icon color="grey" title="Clear Graph" id="graphbutton" v-on:click="clearChart" right>
                <v-icon>delete_outline</v-icon>
              </v-btn>
              <v-btn flat icon color="grey" id="graphbutton" title="show/hide graph" v-on:click="togglegraph">
                <v-icon>visibility_off</v-icon>
              </v-btn>
            </h4>
          </div>
          <div class="card-body" >
            <line-chart :dataChart="dataChart" :countGraph="countGraph" :countGraph2="countGraph2" ></line-chart>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6" id="filterdiv">
          <card title="Umsätze nach Zeiträumen">
            <hr>
            <v-radio-group v-model="selectedInterval" row>
              <v-radio label="Start- und Enddatum" value="flex"></v-radio>
              <v-radio label="nach Monat" value="month"></v-radio>
              <v-radio label="nach Quartal" value="quarter"></v-radio>
              <v-radio label="nach Jahr" value="year"></v-radio>
            </v-radio-group>
                   
            <div class="input-group mb-3" v-if="selectedInterval === 'flex'">
              <input type="date" label="Startdatum" v-model="startdate" class="form-control" aria-label="Startdatum" >
              <input type="date" label="Enddatum" v-model="enddate" class="form-control" aria-label="Enddatum" >
              <div class="input-group-append">
                <button class="btn btn-danger" v-on:click="fetchFlex" type="button"><i class="ti-check"></i></button>
              </div>
            </div>  
                    
            <div  v-if="selectedInterval === 'month'">
              <v-select
                v-model="selectedMonth"
                :items="months"
                item-text="month"
                item-value="value"
                label="Monat"
                return-object
                top
                attach>
              </v-select>
              <button class="btn btn-danger" v-on:click="fetchMonth" type="button"><i class="ti-check"></i></button>
            </div>   
            <div  v-if="selectedInterval === 'quarter'">
              <v-select
                v-model="selectedQuarter"
                :items="quarter"
                item-text="quarter"
                item-value="value"
                label="Quarter"
                return-object
                top
                attach>
              </v-select>
              <button class="btn btn-danger" v-on:click="fetchQuarter" type="button"><i class="ti-check"></i></button>
            </div>   
            <div  v-if="selectedInterval === 'year'">
              <v-select
                v-model="selectedYear"
                :items="years"
                item-text="year"
                item-value="value"
                label="Year"
                return-object
                top
                attach>
              </v-select>
              <button class="btn btn-danger" v-on:click="fetchYear" type="button"><i class="ti-check"></i></button>
            </div>
          </card>
        </div>
        <div class="col-md-3" v-for="stats in statsCards" :key="stats.title">
          <card>
            <div>
              <div class="row">
                <div class="col-5 icon-big text-center" id="statcard" :class="`icon-${stats.type}`">
                  <i  :class="stats.icon"></i>
                </div>
                <div class="col-7 numbers" id="statcard">
                  <p>{{stats.title}}</p>
                  {{stats.value}}
                </div>
              </div>
              <div class="stats">
                <hr/>
                <i :class="stats.footerIcon"></i> {{stats.footerText}}
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" id="filterdiv">
          <card title="Download der Tagesumsätze (Excel)">
           <hr>
            <div>
              <v-radio-group v-model="selectedIntervalUmsatz" row>
                <v-radio label="Tagesumsatz" value="day"></v-radio>
                <v-radio label="Start- und Enddatum" value="flex"></v-radio>
              </v-radio-group>
            </div>
            <div class="input-group mb-3" v-if="selectedIntervalUmsatz === 'day'">
              <input type="date" label="Startdatum" id="downloaddate"  v-model="downloaddate" class="form-control" >
              <div class="input-group-append">
                <button class="btn btn-danger" v-on:click="fetchInvoices(downloaddate, undefined, undefined)" type="button"><i class="ti-file"></i></button>
              </div>
            </div>
            <div class="input-group mb-3" v-if="selectedIntervalUmsatz === 'flex'">
              <input type="date" label="Startdatum" v-model="startdateUmsatz" class="form-control" aria-label="Startdatum" id="flexdownloadStart">
              <input type="date" label="Enddatum" v-model="enddateUmsatz" class="form-control" aria-label="Enddatum" id="flexdownloadEnd">
              <div class="input-group-append">
                <button class="btn btn-danger" v-on:click="fetchInvoices(undefined, startdateUmsatz, enddateUmsatz)" type="button"><i class="ti-file"></i></button>
              </div>
            </div>  
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import LineChart from "@/pages/LineChart";
import moment,{ months } from 'moment';

export default {
  components: {
    VueGoodTable,
    LineChart
  },
  data() {
    return {
      statsCards: [
         {
          type: "danger",
          icon: "ti-wallet",
          title: "Umsatz letzte 30 Tage",
          value: "$1,345",
          footerText: "Updated now",
          footerIcon: "ti-reload"
        },
        {
          type: "danger",
          icon: "ti-server",
          title: "Anzahl Kunden gesamt",
          value: "105GB",
          footerText: "Updated now",
          footerIcon: "ti-reload"
        }],
      selectedMonth: { },
      months: [],
      selectedQuarter: {},
      quarter: [],
      selectedYear: {},
      years: [],
      prevInterval: "",
      selectedInterval: "",
      selectedIntervalUmsatz: "",
      showgraph: true,
      dataChart : {
        labels : [],
        datasets: [{
            label: 'Google Searchvolume (overall)',
            backgroundColor: '#EB5E28',
            borderColor: 'grey',
            pointBackgroundColor: 'white',
            borderWidth: 2,
            pointBorderColor: 'grey',
            data: [],
            hidden: false
            }]
      },
      // Variable wird an LineChart übergeben und löst bei Veränderung ein Update des Graphen aus
      countGraph: 0,
      countGraph2: 0,
      startdate: 0,
      enddate: 0,
      month: 0,
      // rows: [],
      // filter: [],
      // limit: 700,
      // svminimum: 200,
      loading: true,
      graphcount: 0,
      lastSelected: '',
      firstChartlabel: '',
      firstLabel: [],
      firstDataset: [],
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),


      downloaddate: "",
      startdateUmsatz: "",
      enddateUmsatz: "",
      enddateTmp: "",
      umsatzTyp: ""
    };
  },
  //comment
  methods: {
    fetchInvoices(date, startdate, enddate){
      if(date){
        this.umsatzTyp = "daily";
        console.log(this.umsatzTyp);
        var newdate = date.replace("-",".");
        this.fetchInvoiceData('/heimspiel/invoices/' + newdate);
      } else if (startdate && enddate) {
        this.umsatzTyp = "range";
        var tmpStartdate = startdate.replace("-",".");
        var tmpEnddate   = enddate.replace("-",".");
        this.fetchInvoiceData('/heimspiel/invoices/flex/' + tmpStartdate + '&' + tmpEnddate);
      }
    },
    fetchInvoiceData(url) {
      this.$http.get(process.env.VUE_APP_NODE_API_URL + url, { headers: {'Authorization': this.auth }})
        .then(function(response){
          if(response.body.data.length > 0){
            var invoices = response.body.data.map(rechnungen => {
              var rechnung = {};
              rechnung.Nr = rechnungen.ID;
              rechnung.Kunden_Nr = rechnungen.Kunden_Nr;
              rechnung.Lieferdatum = rechnungen.Lieferdatum;
              rechnung.Firma = rechnungen.Firma;
              rechnung.Vorname = rechnungen.Vorname;
              rechnung.Nachname = rechnungen.Nachname;
              rechnung.Strasse = rechnungen.Strasse;
              rechnung.Hausnummer = rechnungen.Hausnummer;
              rechnung.PLZ = rechnungen.PLZ;
              rechnung.Stadt = rechnungen.Stadt;
              rechnung.Typ = rechnungen.Typ;
              rechnung.Pauschale =  parseFloat(rechnungen.Pauschale).toFixed(2).toString().replace('.',',') + ' €';
              if (rechnungen.Einkaufswert === 0) {
                rechnung.Einkaufswert = '0,00 €'
              } else {
                rechnung.Einkaufswert = parseFloat(rechnungen.Einkaufswert).toFixed(2).toString().replace('.',',') + ' €';
              }
              rechnung.Summe = (rechnungen.Pauschale + rechnungen.Einkaufswert).toFixed(2).toString().replace('.',',') + ' €';
              return rechnung;
            })
            this.generateCSV(invoices);
          }
        });
    },
    generateCSV(invoices){
      if (this.umsatzTyp === "daily") {
        var date = this.downloaddate;
        // console.log(date);
      } else if (this.umsatzTyp === "range") {
        var date = this.startdateUmsatz + '-' + this.enddateUmsatz;
        // console.log(date);
      }
      this.$http.post(process.env.VUE_APP_NODE_API_URL + '/heimspiel/json2xls', {data: invoices, date: date}, { headers: {'Authorization': this.auth }})
        .then(function(response){
          console.log(response);
        window.location = process.env.VUE_APP_NODE_API_URL + response.body;
      });
    },
    fetchCustomerCount() {
      this.$http.get('https://katsios-kesting.de:444/uhl/heimspiel/customer/', { headers: {'Authorization': this.auth }})
			  .then(function(response){

          
          this.statsCards[1].value = response.body.data[0].Kunden;
        });
    },
    fetchRevenue() {
      this.$http.get('https://katsios-kesting.de:444/uhl/heimspiel/lastorders/', { headers: {'Authorization': this.auth }})
			  .then(function(response){
          let sum = (response.body.data[0].Einkaufswert + response.body.data[0].Pauschale).toFixed(0);
          this.statsCards[0].value = "€" + sum;
        });
    },
    fetchFlex(){
        var start = new Date(this.startdate);
        var end = new Date(this.enddate);
        var sdd = String(start.getDate()).padStart(2, '0');
        var edd = String(end.getDate()).padStart(2, '0');
        var smm = String(start.getMonth() + 1).padStart(2, '0'); //January is 0!
        var emm = String(end.getMonth() + 1).padStart(2, '0'); //January is 0!
        var syyyy = start.getFullYear();
        var eyyyy = end.getFullYear();
       
       this.$http.get('https://api.uhl.katsios-kesting.de/dailyIncome/'+ this.startdate +'&'+ this.enddate)
        .then(function(response){
          var umsaetze = [];
          var label = [];
            for (var i = 0; i<response.body.length; i++){
                umsaetze.push(response.body[i].Einkaufswert + response.body[i].Pauschale)
                var datum = response.body[i].Lieferdatum;
                label.push(datum.substring(0,5));
            }
             if (this.dataChart.labels.length != label.length || this.selectedInterval != this.lastSelected ){
              this.dataChart.datasets.length = 1;
              this.dataChart.datasets[0].data = umsaetze; 
              this.dataChart.datasets[0].label = "Umsätze " + sdd +"."+ smm +"." + syyyy + " bis " + edd +"."+ emm +"." + eyyyy ;
              this.dataChart.labels = label;
              this.countGraph++; 
              this.lastSelected = this.selectedInterval;
            } else{
              let newData = {
                    label: "Umsätze " + sdd +"."+ smm +"." + syyyy + " bis " + edd +"."+ emm +"." + eyyyy ,
                    backgroundColor: '#EB5E28',
                    borderColor: 'grey',
                    pointBackgroundColor: 'white',
                    borderWidth: 2,
                    pointBorderColor: 'grey',
                    data: umsaetze
                    
              };
              var unilabel = [];
              if(this.dataChart.labels.length<label.length){
                for (var j = 1; j < label.length+1; j++){
                  unilabel.push(j)
                }
                this.dataChart.labels = unilabel;
              } else {
                for (var j = 1; j < this.dataChart.labels.length+1; j++){
                  unilabel.push(j)
                }
                this.dataChart.labels = unilabel;
              }
              this.dataChart.labels = unilabel;
              this.lastSelected = this.selectedInterval;
              this.dataChart.datasets.unshift(newData);

              this.countGraph++;
            }
         })
    },
    fetchMonth(){
      
      this.$http.get('https://katsios-kesting.de:444/uhl/heimspiel/month/'+ this.selectedMonth.monthvalue +'&'+ this.selectedMonth.year, { headers: {'Authorization': this.auth }})
        .then(function(response){
          var umsaetze = [];
          var label = [];
            for (var i = 0; i<response.body.data.length; i++){
                umsaetze.push(response.body.data[i].Einkaufswert + response.body.data[i].Pauschale)
                var datum = response.body.data[i].Lieferdatum;
                label.push(datum.substring(0,5));
            }
            if (this.dataChart.labels.length <= label.length+5 && this.dataChart.labels.length >= label.length-5 && this.selectedInterval == this.lastSelected ){
              
              let newData = {
                    label:  "Umsätze "  + this.selectedMonth.month ,
                    backgroundColor: '#EB5E28',
                    borderColor: 'grey',
                    pointBackgroundColor: 'white',
                    borderWidth: 2,
                    pointBorderColor: 'grey',
                    data: umsaetze
                    
              };
              var unilabel = [];
              if(this.dataChart.labels.length<label.length){
                for (var j = 1; j < label.length+1; j++){
                  unilabel.push(j)
                }
                this.dataChart.labels = unilabel;
              } else {
                for (var j = 1; j < this.dataChart.labels.length+1; j++){
                  unilabel.push(j)
                }
                this.dataChart.labels = unilabel;
              }
              this.lastSelected = this.selectedInterval;
              this.dataChart.datasets.unshift(newData);

              this.countGraph++;
            } else{
              this.dataChart.datasets.length = 1;
              this.dataChart.datasets[0].data = umsaetze; 
              this.dataChart.datasets[0].label = "Umsätze "  + this.selectedMonth.month ;
              this.dataChart.labels = label;
              this.countGraph++; 
              this.lastSelected = this.selectedInterval;
            }

         })
    },
    fetchQuarter(){
       
      this.$http.get('https://katsios-kesting.de:444/uhl/heimspiel/quarter/'+ this.selectedQuarter.quartervalue +'&'+ this.selectedQuarter.year, { headers: {'Authorization': this.auth }})
        .then(function(response){
          var umsaetze = [];
          var label = [];
          

            for (var i = 0; i<response.body.data.length; i++){
                umsaetze.push(response.body.data[i].Einkaufswert + response.body.data[i].Pauschale);
               
                label.push(response.body.data[i].Woche);
            }
              if (this.dataChart.labels.length <= label.length+1 && this.dataChart.labels.length >= label.length-1 && this.selectedInterval == this.lastSelected ){
              
              let newData = {
                    label: "Umsätze " + this.selectedQuarter.quarter + " nach Woche" ,
                    backgroundColor: '#EB5E28',
                    borderColor: 'grey',
                    pointBackgroundColor: 'white',
                    borderWidth: 2,
                    pointBorderColor: 'grey',
                    data: umsaetze
              };
              var unilabel = [];
              if(this.dataChart.labels.length<label.length){
                
                for (var j = 1; j < label.length+1; j++){
                  unilabel.push(j)
                }
                this.dataChart.labels = unilabel;
              } else {
                // console.log("alte chart grösse neue chart")
                for (var j = 1; j < this.dataChart.labels.length+1; j++){
                  unilabel.push(j)
                }
                this.dataChart.labels = unilabel;
              }
              this.dataChart.labels = unilabel;
              this.lastSelected = this.selectedInterval;
              this.dataChart.datasets.unshift(newData);

              this.countGraph++;
            } else{
             this.dataChart.datasets.length = 1;
              this.dataChart.datasets[0].data = umsaetze; 
              this.dataChart.datasets[0].label = "Umsätze " + this.selectedQuarter.quarter + " nach Woche";
              this.dataChart.labels = label
              this.lastSelected = this.selectedInterval;
              this.countGraph++; 
            }    
         })
    },
    fetchYear(){
      this.dataChart.datasets[0].label = "Umsätze " + this.selectedYear.year + " nach Monat" ;
      this.$http.get('https://katsios-kesting.de:444/uhl/heimspiel/year/'+ this.selectedYear.year, { headers: {'Authorization': this.auth }})
        .then(function(response){
          var umsaetze = [];
          var label = [];
            for (var i = 0; i<response.body.data.length; i++){
                umsaetze.push(response.body.data[i].Einkaufswert + response.body.data[i].Pauschale);
               
                label.push(response.body.data[i].Monat);
            }
            
             if (this.dataChart.labels.length != label.length || this.selectedInterval != this.lastSelected ){
              this.dataChart.datasets.length = 1;
              this.dataChart.datasets[0].data = umsaetze; 
              this.dataChart.datasets[0].label = "Umsätze " + this.selectedYear.year + " nach Monat";
              this.dataChart.labels = label;
              this.countGraph++; 
              this.lastSelected = this.selectedInterval;
            } else{
              let newData = {
                    label: "Umsätze " + this.selectedYear.year + " nach Monat",
                    backgroundColor: '#EB5E28',
                    borderColor: 'grey',
                    pointBackgroundColor: 'white',
                    borderWidth: 2,
                    pointBorderColor: 'grey',
                    data: umsaetze
                    
              };
              var unilabel = [];
              if(this.dataChart.labels.length<label.length){
                for (var j = 1; j < label.length+1; j++){
                  unilabel.push(j)
                }
                this.dataChart.labels = unilabel;
              } else {
                for (var j = 1; j < this.dataChart.labels.length+1; j++){
                  unilabel.push(j)
                }
                this.dataChart.labels = unilabel;
              }
              this.dataChart.labels = unilabel;
              this.lastSelected = this.selectedInterval;
              this.dataChart.datasets.unshift(newData);

              this.countGraph++;
            }
         })
    },
    clearChart(){
        this.dataChart.datasets[0].data = this.firstDataset;
        this.dataChart.labels = this.firstLabel;
        this.dataChart.datasets[0].label = this.firstChartlabel;
        this.dataChart.datasets.length = 1;
        // console.log(this.firstLabel)
        this.countGraph2++;    
    },
    togglegraph(){
      this.showgraph = !this.showgraph;
    },
    generateMonth(){
      var monthArray = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var endMonth = parseInt(moment().format('M'));
      var endYear = parseInt(moment().format('YYYY'));

      var monthValues= [];
      var yearValues = [];

      for (var i = 0 ; i<12;i++){
        if (endMonth==0){
          endMonth =12;
          endYear = endYear - 1;
        }
        yearValues.push(endYear);
        monthValues.push(endMonth);
        endMonth = endMonth - 1;
      }

      for (var j= 0; j<12; j++){
      
        let selectMonth = {month: monthArray[monthValues[j]]+ " " + yearValues[j], monthvalue: monthValues[j], year: yearValues[j] };
        this.months.push(selectMonth);
      }
      
      // for (let yearCounter = startYear; yearCounter <= endYear; yearCounter++) { 
      //     if (yearCounter === endYear) {
      //       for (let monthCounter = ; index < array.length; index++) { //solange bis endMOnth erreicht wurde
      //         const element = array[index];
              
      //       }
      //     }else{
      //       let monthcounter = 12;
      //       for (let index = 1; index <= monthcounter; index++) {

      //       }
      //     }
      // }
    },
    generateQuarter(){
      var quarterArray = ['', '1. Quartal', '2. Quartal', '3. Quartal', '4.Quartal'];
      var endQuarter = parseInt(moment().format('Q'));
      var endYear = parseInt(moment().format('YYYY'));

      var quarterValues= [];
      var yearValues = [];

      for (var i = 0 ; i<4;i++){
        if (endQuarter==0){
          endQuarter =4;
          endYear = endYear - 1;
        }
        yearValues.push(endYear);
        quarterValues.push(endQuarter);
        endQuarter = endQuarter - 1;
      }

      for (var j= 0; j<4; j++){
      
        let selectQuarter = {quarter: quarterArray[quarterValues[j]]+ " " + yearValues[j], quartervalue: quarterValues[j], year: yearValues[j] };
        this.quarter.push(selectQuarter);
      }
      
      
    },
    generateYear(){
      var endYear = parseInt(moment().format('YYYY'));
      var yearValues = [];

      for (var i = endYear ; i>2017;i--){ 
        yearValues.push(i);
      }
      for (var j= 0; j<yearValues.length; j++){
        let selectYear = { year: yearValues[j] };
        this.years.push(selectYear);
      } 
    }
  },
  created: function(){
    this.fetchCustomerCount();
    this.fetchRevenue();
  },
  async mounted () {
    this.generateMonth();
    this.generateQuarter();
    this.generateYear();
    // this.loaded = false
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    var enddate = yyyy+ '-' + mm + '-' + dd;
    var endlabel = dd + "." + mm + "." + yyyy;
    today = new Date(today.setDate(today.getDate() - 30))
    dd = String(today.getDate()).padStart(2, '0');
    mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    yyyy = today.getFullYear();
    var startdate = yyyy+ '-' + mm + '-' + dd;
    var startlabel = dd + "." + mm + "." + yyyy;
    this.dataChart.datasets[0].label = "Umsätze " + startlabel + " bis " + endlabel;
    this.firstChartlabel = "Umsätze " + startlabel + " bis " + endlabel;
    await this.$http.get('https://api.uhl.katsios-kesting.de/dailyIncome/'+ startdate +'&'+ enddate )
        .then(function(response){
          var umsaetze = [];
          var label = [];
            for (var i = 0; i<response.body.length; i++){
                umsaetze.push(response.body[i].Einkaufswert + response.body[i].Pauschale)
                var datum = response.body[i].Lieferdatum
                label.push(datum.substring(0,5))
            }
            this.dataChart.labels = label
            this.dataChart.datasets[0].data = umsaetze;  
            this.loading =false;
            this.firstDataset = umsaetze;
            this.firstLabel = label;
         });

    //set downloaddate max = today
    this.enddateTmp = enddate;
    // document.getElementById("downloaddate").setAttribute("max", enddate);
  },
  updated () {
    if (this.selectedIntervalUmsatz === 'day') {
      document.getElementById("downloaddate").setAttribute("max", this.enddateTmp);
    } else if (this.selectedIntervalUmsatz === 'flex') {
      document.getElementById("flexdownloadStart").setAttribute("max", this.enddateTmp);
      document.getElementById("flexdownloadEnd").setAttribute("max", this.enddateTmp);
    }
  }
};
</script>

<style>
#graphbutton{
  margin-top: 0%;
  float:right;
  /* margin-left:auto; 
  margin-right:0; */
}
#graphheader{
  padding-bottom: 0%
}
.tablecard{
  padding-bottom: 1%;
}
#center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50vh;
}
#frame{
  padding-left: 0px;
  padding-right: 0px;
}
</style>